import {
  Component,
  HostListener,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthService, GoogleApiService, StorageService } from './amm-share/services';
import { SseService } from './amm-share/services/sse.service';
import { CommonStore, ViewDetailStore } from './amm-share/stores';
import { MessagingStore } from './amm-share/stores/amm-message.store';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil, timer } from 'rxjs';
import { environment } from '../environments/environment';
import { ToastModule, ToastPositionType } from 'primeng/toast';
import { APPCONSTANT } from './amm-share/constants';

@Component({
  selector: 'amm-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],

  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Amm-Buyer';

  public messagingStore = inject(MessagingStore);

  private commonStore = inject(CommonStore);
  private sseService = inject(SseService);
  private storageService = inject(StorageService);
  private authService = inject(AuthService);
  private messageService = inject(MessageService);
  private viewDetailStore = inject(ViewDetailStore);
  private ngZone = inject(NgZone);
  private platformId = inject(PLATFORM_ID);
  private destory$: Subject<boolean> = new Subject<boolean>();

  constructor() { }

  ngOnInit(): void {
    this.viewDetailStore.fetchCurTemplate();

    this.commonStore.loadAllCategory();
    this.commonStore.loadCategoryList();
    //this.messagingStore.loadConversations();
    this.commonStore.loadStatesByCountry('US');
    this.commonStore.loadAllCountries();
    this.commonStore.loadAllCancelReasons();

    if (isPlatformBrowser(this.platformId)) {
      this.authService.sessionExpired$
        .pipe(takeUntil(this.destory$))
        .subscribe(() => {
          this.messageService.add({
            severity: 'warn',
            summary: 'Session expired',
            detail: 'Your login has expired. Please log in again.',
            key: 'general-notification',
          });
        });
      const jwt = this.storageService.getJWT();
      if (jwt) {
        this.sseService.connectToSSE(jwt);
      }
      this.ngZone.runOutsideAngular(() => {
        timer(0, environment.jwtExpireCheckInterval).subscribe(() => {
          const jwt = this.storageService.getJWT();
          if (jwt && this.authService.isTokenExpired(jwt)) {
            // token 已过期,服务端没有会话可登出,只做本地清理
            this.ngZone.run(() => this.authService.expireSession());
          }
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.sseService.abortSSE();
    this.destory$.next(true);
    this.destory$.complete();
  }

  @HostListener('window:storage')
  onLocalStorageChange() { }


  getToastPosition(): ToastPositionType {
    if (!isPlatformBrowser(this.platformId)) return 'top-right';
    const isSmallSize = window.innerWidth <= APPCONSTANT.SMALL_SIZE_WIDTH;
    return isSmallSize ? 'bottom-center' : 'top-right';
  }
}
